import {LOCK_VENDORS} from './constants';
import type {Unlock} from './types';

const VENDORS_WITH_MULTIPLE_ROOMS = [LOCK_VENDORS.saltoV2, LOCK_VENDORS.saltoKSBeta];

const hasMultipleRooms = (unlock: Unlock) =>
  VENDORS_WITH_MULTIPLE_ROOMS.includes(unlock.lock?.vendor);

export {hasMultipleRooms};
